<template>
    <div class="section-box">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="手动录入" name="entering">
                <div class="one-ruleForm">
                    <el-button type="warning" class="next-button"  size="small" @click="handleResets">重置</el-button>
                    <div style="width: 800px; min-height: 700px;" >
                        <EditModal ref="enterings" @onSubmit="onSubmit" />
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="Excel" name="excel">
                <div class="one-ruleForm">
                    <div style="min-height: 700px;" class="upload-box">
                        <div>
                            <p>Excel导入试题功能支持“单选题、多选题、判断题、填空题、问答题”五类题型的导入</p>
                            <p>第一步：下载Excel试题模版</p>
                            <p>第二步：使用模版整理试题，点击“上传Excel”完成试题导入</p>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <div class="excel-btn-box">
                                <el-button @click="downLoadTemplate">导出模板</el-button>
                                <el-button type="primary" class="upload-m-btn" icon="el-icon-plus">
                                    <input
                                        type="file"
                                        class="fileUpload"
                                        ref="fileUpload"
                                        @change="fileChange($event.target.files)"
                                        accept=".csv, .xls,.xslx,.xlsx"
                                    />
                                        <!-- accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" -->
                                上传Excel</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import EditModal from './index/editModal'
import { mapActions } from "vuex";
import {
    questionBankModel,              //试题 新增/修改
    uploadExcelExcelImport,         //导入
} from "@/service/examination";
import { getStorageUserRoleId } from '@/utils/store'
export default {
    components: {
      EditModal
    },
    data() {
        return {
            activeName:'entering'
        }
    },
    methods: {
        ...mapActions('app', [
            'removeTabList'
        ]),
        handleResets(){
            this.$refs.enterings.handleReset();
        },
        onSubmit(val) {
            questionBankModel(val).then(res=> {
                console.log(res)
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('添加成功！')
                setTimeout(() => {
                    this.removeTabList({
                        id: this.$route.meta.menuId,
                    })
                    this.$router.push('/examination/questionBank')
                    this.handleResets()
                    this.activeName = 'entering'
                }, 300)
            })
        },
        // 导入回款信息
        fileChange(file) {
            console.log(file)
            const loading = this.$loading({
                lock: true,
                text: "上传中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            uploadExcelExcelImport({
                userId: getStorageUserRoleId(),
                file: file[0]
            }).then(res => {
                loading.close();
                this.$refs.fileUpload.value = null;
                if ( typeof res == 'object'&&res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success("导入成功");
                setTimeout(() => {
                    this.removeTabList({
                        id: this.$route.meta.menuId,
                    })
                    this.$router.push('/examination/questionBank')
                    this.activeName = 'entering'
                }, 300)
            });
        },
        // 下载文件模板
        downLoadTemplate() {
            let url = process.env.NODE_ENV == 'development' ? '/api2' : process.env.VUE_APP_API2
            let a = document.createElement("a");
            a.setAttribute('href',url+'/questionBank/export');
            a.setAttribute('target', '_blank');
            document.body.appendChild(a);
            a.click();
        }
    }
}
</script>

<style lang="scss">
.el-tabs__header {
    margin: 0 0 30px;
}
.el-tabs__content {
    overflow: visible;
}
.el-tabs__item {
    min-width: 100px;
    text-align: center;
}
.one-ruleForm {
    position: relative;
    .next-button {
      position: absolute;
      right: 0;
      top: -70px;
    }
}
.upload-box {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.upload-m-btn {
  position: relative;
  .fileUpload {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
  }
}
.excel-btn-box {
    display: flex;
    justify-content: space-around;
}
</style>